import { OpenAIIcon, ClaudeIcon, AnthropicIcon, GeminiIcon, BedrockIcon, XAIIcon } from "@/assets/svg/providers"
import { cn } from "@/lib/utils"

interface ProviderPillProps {
  provider: string
  className?: string
  showIcon?: boolean
  iconOnly?: boolean
}

// Provider icon component
export const ProviderIcon = ({ provider, className }: { provider: string; className?: string }) => {
  const providerLower = provider?.toLowerCase() || ""

  if (providerLower === "openai") {
    return <OpenAIIcon className={cn("shrink-0", className)} />
  }

  if (providerLower === "claude") {
    return <ClaudeIcon className={cn("shrink-0", className)} />
  }

  if (providerLower === "anthropic") {
    return <AnthropicIcon className={cn("shrink-0", className)} />
  }

  if (providerLower === "gemini" || providerLower === "google") {
    return <GeminiIcon className={cn("shrink-0", className)} />
  }

  if (providerLower === "bedrock" || providerLower === "aws" || providerLower === "amazon") {
    return <BedrockIcon className={cn("shrink-0", className)} />
  }

  if (providerLower === "xai" || providerLower === "grok") {
    return <XAIIcon className={cn("shrink-0", className)} />
  }

  return null
}

export function ProviderPill({
  provider,
  className,
  showIcon = true,
  iconOnly = false
}: ProviderPillProps) {
  const icon = showIcon ? <ProviderIcon provider={provider} className="w-3.5 h-3.5" /> : null

  // Proper display names for providers
  const getDisplayName = (provider: string) => {
    const lowerProvider = provider?.toLowerCase() || ""
    if (lowerProvider === "openai") return "OpenAI"
    // Capitalize first letter for other providers
    return provider.charAt(0).toUpperCase() + provider.slice(1)
  }

  if (iconOnly && icon) {
    return icon
  }

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1",
        "bg-muted/50 text-xs font-medium",
        "border border-border/40",
        className
      )}
    >
      {icon}
      <span>{getDisplayName(provider)}</span>
    </div>
  )
}
